import { render } from "./Virgo.vue?vue&type=template&id=2281d7a4&scoped=true"
import script from "./Virgo.vue?vue&type=script&lang=js"
export * from "./Virgo.vue?vue&type=script&lang=js"

import "./Virgo.vue?vue&type=style&index=0&id=2281d7a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2281d7a4"]])

export default __exports__